// @ts-nocheck
import CurrencyLogo from "components/CurrencyLogo";
import { RowBetween } from "components/Row";
import TransactionConfirmationModal, { ConfirmationModalContent } from "components/TransactionConfirmationModal";
import { utils } from "ethers";
import { useToken } from "hooks/Tokens";
import { useAssetVaultContract } from "hooks/useContract";
import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components/macro";
import { AssetDetails } from "types/position";
import { unwrappedToken } from "utils/unwrappedToken";

import { TransactionResponse } from "@ethersproject/providers";

import { TransactionType } from "../../state/transactions/actions";
import { useTransactionAdder } from "../../state/transactions/hooks";
import { useTokenBalance } from "../../state/wallet/hooks";

const PrimaryPositionIdData = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  > * {
    margin-right: 8px;
  }
`

const DataText = styled.div`
  font-weight: 600;
  font-size: 18px;
  color: white;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 14px;
  `};
`

interface AssetListItemProps {
  setActiveKey: (value: bundleID) => void;
  activeKey: bundleID;
  key: string;
  positionDetails: AssetDetails;
  index: number,
}

export default function AssetListItem({ setActiveKey, activeKey, key, positionDetails, index }: AssetListItemProps) {
  const {
    asset: tokenAddress,
    amount: tokenAmountRaw
  } = positionDetails

  // const { chainId } = useActiveWeb3React()
  const assetManager = useAssetVaultContract()
  const addTransaction = useTransactionAdder()
  const token = useToken(tokenAddress)
  const currency = token ? (token.tokenInfo ? token.tokenInfo : unwrappedToken(token)) : undefined
  const tokenAmount = utils.formatUnits(tokenAmountRaw, currency?.decimals)
  const userTokenBalanceRaw = useTokenBalance(assetManager?.address ?? undefined, token)
  const userTokenBalance = utils.formatUnits(userTokenBalanceRaw ? userTokenBalanceRaw?.quotient.toString() : "0", currency?.decimals)
  // speed up popup dismisall time if on L2
  // const isL2 = Boolean(chainId && L2_CHAIN_IDS.includes(chainId))
  const [collapse, setCollapse] = useState(true)
  const history = useHistory()
  const [amount, setAmount] = useState('')
  const [showConfirm, setShowConfirm] = useState<boolean>(false)
  const [attemptingTxn, setAttemptingTxn] = useState<boolean>(false) // clicked confirm
  const [txHash, setTxHash] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [invalid, setInvalid] = useState<boolean>(false)
  const [insufficient, setInsufficient] = useState<boolean>(false)

  useEffect(() => {
    if (tokenAddress === activeKey) {
      setCollapse(false)
    } else {
      setCollapse(true)
    }

  }, [activeKey, tokenAddress])

  const handleDismissConfirmation = useCallback(() => {
    setShowConfirm(false)
    // if there was a tx hash, we want to clear the input
    if (txHash) {
      setTxHash('')
    }
    history.go(0)
  }, [txHash, history])

  const onChangeCollapse = () => {
    if (collapse) {
      setActiveKey(tokenAddress)
    } else {
      setActiveKey('')
    }
  }

  const onConfirmClick = async () => {
    const value = parseFloat(amount)
    if (assetManager && value > 0 && value <= parseFloat(tokenAmount)) {
      try {
        setLoading(true)
        const withdrawAmount = utils.parseUnits(amount, currency?.decimals).toString();
        await assetManager.withdraw(tokenAddress, withdrawAmount)
          .then(async (response: TransactionResponse) => {
            addTransaction(response, {
              type: TransactionType.WITHDRAW_POSITION
            })
            setTxHash(response.hash)
            setAttemptingTxn(false)
            setShowConfirm(true);
            await response.wait()
            setLoading(false)
            // setShowConfirm(true)
          })
      } catch (error) {
        setLoading(false)
        console.error('Failed to send transaction', error)
        // we only care if the error is something _other_ than the user rejected the tx
        if (error?.code !== 4001) {
          console.error(error)
        }
      } finally {
        setAttemptingTxn(false)
      }
    } else {
      setInvalid(true)
      /*addPopup(
        {
          reason: 'Invalid Withdraw Amount'
        },
        Date.now(),
        isL2 ? L2_TXN_DISMISS_MS : DEFAULT_TXN_DISMISS_MS
      )*/
    }
  }

  const onAmountChange = (e) => {
    const value = e.target.value
    const splited = value.toString().split('.')
    if (splited.length > 1) {
      setInvalid(splited[1].length > 18)
    } else {
      setInvalid(false)
    }
    const maxAmount = (parseFloat(userTokenBalance) > parseFloat(tokenAmount) ? parseFloat(tokenAmount) : parseFloat(userTokenBalance));
    setInsufficient(parseFloat(value) > maxAmount || parseFloat(value) < 0)
    setAmount(value.toString())
  }

  const onMaxReached = () => {
    const maxValue = parseFloat(userTokenBalance) > parseFloat(tokenAmount) ? tokenAmount : userTokenBalance;
    setAmount(maxValue)
  }

  return (
    <>
      <TransactionConfirmationModal
        isOpen={showConfirm}
        onDismiss={handleDismissConfirmation}
        attemptingTxn={attemptingTxn}
        hash={txHash}
        content={() => (
          <ConfirmationModalContent
            title={'Confirm Withdraw'}
            onDismiss={handleDismissConfirmation}
            bottomContent={() => (
              <button className='view-etherscan'>
                <p>
                  View on Block explorer
                </p>
              </button>
            )}
          />
        )}
      />
      <RowBetween>
        <>
          <div className='single-liquidity' style={index%2===0?{backgroundColor:'#2F2A3C'}:{backgroundColor:'#201D29'}}>
            <div onClick={onChangeCollapse} style={{ cursor: 'pointer' }}>
              <div className='single-liquidity-header'>
                <div className='single-liquidity-header-left'>
                  <PrimaryPositionIdData>
                    {
                      currency &&
                        <>
                          <CurrencyLogo currency={currency} size={'32px'} style={{ marginRight: '12px' }} />
                          <DataText>
                            &nbsp;{currency?.symbol}&nbsp;&nbsp;
                          </DataText>
                          &nbsp;
                        </>
                    }
                  </PrimaryPositionIdData>
                </div>
                <div className='single-liquidity-header-right'>
                  <p style={{ marginRight: '10px' }}>{(+tokenAmount).toFixed(2)}</p>
                  <img src='./images/up2.png' alt="up"
                       style={{ width: '20px', height: '20px', display: collapse ? 'none' : 'block' }} />
                  <img src='./images/down2.png' alt="down"
                       style={{ width: '20px', height: '20px', display: collapse ? 'block' : 'none' }} />
                </div>
              </div>
            </div>
            <div className='single-liquidity-content' style={{ height: collapse ? '0px' : '120px', overflow: 'hidden' }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                <input
                  value={amount}
                  type='number'
                  placeholder={"0.0"}
                  onChange={onAmountChange}
                  onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                  id='add-liquidity-input-tokena'
                  className='changeWithdrawAmountInput'
                  style={{opacity: (loading ? 0.45 : 1)}}
                  disabled={loading}
                />
                <p className='single-token-left' style={{ cursor: (loading ? 'auto' : 'pointer'), opacity: (loading ? 0.45 : 1) }}
                   onClick={() => {
                     if (loading) return
                     onMaxReached()
                   }}>
                  Maximum: {(parseFloat(userTokenBalance) > parseFloat(tokenAmount) ? parseFloat(tokenAmount) : parseFloat(userTokenBalance)).toFixed(6)}
                </p>
              </div>
              <div style={{ display: collapse ? 'none' : 'flex', justifyContent: 'center', transition: '0.5s' }}>
                <button className={(invalid || insufficient) ? 'primary-button-invalid' : 'primary-button'} onClick={onConfirmClick} disabled={loading || invalid || insufficient}>
                  {
                    invalid || insufficient ?
                      <p>Invalid Withdrawal Amount</p>
                      :
                      <p>Withdraw{loading ? "ing..." : ""}</p>
                  }
                </button>
              </div>
            </div>
          </div>
        </>
      </RowBetween>
    </>
  )
}
